import { getLatestData } from '../Utils/GetLatestData'
import { WizardContext, WizardEvent } from '../wizardMachine'

export const needsGuarantor = (context: WizardContext, event: WizardEvent): boolean => {
  const { applicants, qualification, index } = getLatestData(context, event)

  if (qualification && applicants && applicants[index]) {
    const applicant = applicants[index]

    const { situation_guarantor_needed, situation_guarantor_asked } = qualification

    return [...(situation_guarantor_needed ?? []), ...(situation_guarantor_asked ?? [])].some(
      (situation) => situation === applicant.situation
    )
  }

  return false
}
